import { localStorageUtil } from '../../utils/local-storage.util';

export const prevPageStorage = localStorageUtil<string>('prevPage');
